<template>
    <div class="container" style="height:calc(100vh - 100px)">
        <v-row>
            <v-col
                cols="12">
                    <v-icon
                    small
                    color="#000"
                    >
                    mdi-format-list-text
                    </v-icon>
                    <b> REPORTE DE RESET</b>
            </v-col>
        </v-row>
        <!--
        <v-row>
            <v-col
                cols="12">
                    <v-btn
                    :loading="loading3"
                    :disabled="loading3"
                    color="info"
                    class="ma-2"
                    @click="procesarRest()"
                    >
                    Buscar
                        <v-icon
                            right
                        >
                            mdi-magnify
                        </v-icon>
                    </v-btn>
            </v-col>
        </v-row>
        -->
        <v-row>
            <v-col
                cols="12">
                    <v-simple-table
                    fixed-header
                    height="700px">
                        <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-left">
                                Mes
                            </th>
                            <th class="text-left">
                                Reset de cuenta
                            </th>
                            <th class="text-left">
                                Petición
                            </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                            v-for="item in listInitial"
                            :key="item.inicio"
                            >
                            <td>{{ item.inicio }}</td>
                            <td>{{ item.reset }} <v-icon style="cursor:pointer" @click="copyText(item.inicio,item.reset,'R')" right>mdi-content-copy</v-icon></td>
                            <td>{{ item.peticion }} <v-icon style="cursor:pointer" @click="copyText(item.inicio,item.peticion,'P')" right>mdi-content-copy</v-icon></td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  //import HelloWorld from '../components/HelloWorld'
  import UtilMethod from '../util/utilMethod';

  export default {
    name: 'Reset',

    data:()=>({
        loader: null,
        loading: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,
        
        listInitial: [],
    }),
    components: {
      //HelloWorld,
    },
    mounted(){
        this.procesarRest();
    },
    methods:{
        async procesarRest(){
            this.loader = this.loading3;
            const week = [
                "DOMINGO",
                "LUNES",
                "MARTES",
                "MIERCOLES",
                "JUEVES",
                "VIERNES",
                "SABADO",
            ]

            const monthText = [
                "enero",
                "febrero",
                "marzo",
                "abril",
                "mayo",
                "junio",
                "julio",
                "agosto",
                "septiembre",
                "octubre",
                "noviembre",
                "diciembre",
            ]

            let callbackThen = (response) => {
                let objOut = {
                    code:null,
                    message:null,
                    data:null
                };

                if(response.status == 200){
                    let res = response.data;
                    objOut.code = (res.meta.code==200)?1:res.meta.code;
                    objOut.message = "Data extraida correctamente";//res.message;
                    objOut.data = res.response.holidays;
                    if(res.meta.code == 200 && res.response.holidays.length > 0){
                        objOut.message += "\n\n";
                        res.response.holidays.forEach((item,i,arr) => {
                        objOut.message += "<b>FERIADO</b> "+item.date.iso+"\n\n"
                        });
                    }
                }else{
                    objOut.message = "Oops, algo pasó..., Code: "+response.status;
                }
                
                return objOut;
            }
            let objOutApi = await UtilMethod.execApi("GET","https://calendarific.com/api/v2/holidays?api_key=40401cc12c477222b552f65396026644ba9398b4&country=CO&year=2022",null,null,callbackThen);
              
            let year = 2023;
            let month = 1;
            month--;
            const date = new Date();//new Date(year, month, 1);
            const dates = [];
            let factor = 15;

            while (date.getFullYear() === year) {
                let objRest = {
                    inicio:null,
                    reset:null,
                    peticion:null
                };
                let dateIter = new Date(date);
                let dateIterAux = dateIter;
                let strDateActual = dateIter.getDate().toString().padStart(2,"0") + "/" + (dateIter.getMonth()+1).toString().padStart(2,"0") +"/"+dateIter.getFullYear();
                let strFormatDateActual = dateIter.getDate().toString().padStart(2,"0") + " de " + monthText[dateIter.getMonth()] +" del "+ dateIter.getFullYear();
                objRest.inicio = dateIter.getDate().toString().padStart(2,"0") + "/" + (dateIter.getMonth()+1).toString().padStart(2,"0") +"/"+dateIter.getFullYear();
                
                let i = 0;
                let ret = "";
                let retStrDate5 = "";
                let retStrDate15 = "";
                let retText5 = "";
                let retText15 = "";
                while(i < factor){
                //REVISAR LOGICA
                dateIterAux.setDate(dateIterAux.getDate() + 1);
                dateIterAux = new Date(dateIterAux);

                //<!--VALIDAR FERIADOS Y FINES DE SEMANA
                let existHoliday = false;
                if(objOutApi.data != null ){
                    existHoliday = objOutApi.data.find(item => {
                    return item.date.datetime.year == dateIterAux.getFullYear() &&
                            item.date.datetime.month == (dateIterAux.getMonth()+1) &&
                            item.date.datetime.day == dateIterAux.getDate()
                    });
                }

                if((dateIterAux.getDay() != 6 && dateIterAux.getDay() != 0) && !existHoliday){
                    i++;
                }
                
                if(/*i == factor*/ i == 5){
                    retStrDate5 = dateIterAux.getDate().toString().padStart(2,"0") + "/" + (dateIterAux.getMonth()+1).toString().padStart(2,"0") +"/"+ dateIterAux.getFullYear();
                    let formatDate5 = dateIterAux.getDate().toString().padStart(2,"0") + " de " + monthText[dateIterAux.getMonth()] +" del "+ dateIterAux.getFullYear();
                    retText5 = `Para Flash es muy importante atender su requerimiento en el menor tiempo posible. Su Petición, recibido el ${strFormatDateActual} ha sido identificado con Ticket No. XXXX, será contestada a más tardar el día ${formatDate5} a través del mismo medio de atención por el que la presentó o por el medio de su elección. Si su Petición no es atendida en la fecha indicada, se entenderá que ha sido resuelta a su favor. (Esto se llama Silencio Administrativo positivo).`;
                }

                if(/*i == factor*/ i == 15){
                    retStrDate15 = dateIterAux.getDate().toString().padStart(2,"0") + "/" + (dateIterAux.getMonth()+1).toString().padStart(2,"0") +"/"+ dateIterAux.getFullYear();
                    let formatDate15 = dateIterAux.getDate().toString().padStart(2,"0") + " de " + monthText[dateIterAux.getMonth()] +" del "+ dateIterAux.getFullYear();
                    retText15 = `Para Flash es muy importante atender su requerimiento en el menor tiempo posible. Su Petición, recibido el ${strFormatDateActual} ha sido identificado con Ticket No. XXXX CUN No. XXX, será contestada a más tardar el día ${formatDate15} a través del mismo medio de atención por el que la presentó o por el medio de su elección. Si su Petición no es atendida en la fecha indicada, se entenderá que ha sido resuelta a su favor. (Esto se llama Silencio Administrativo positivo).`;
                }

                
                //-->
                
                }
                objRest.reset =  retStrDate5;
                objRest.peticion =  retStrDate15;
                date.setDate(date.getDate() + 1);
                this.listInitial.push(objRest);
            }
        },
        copyText(fechaIni, fechaFin, type){
            //document.execCommand('copy');
            let formatIni = this.formatDateSlashToText(fechaIni);
            let formatFin = this.formatDateSlashToText(fechaFin);
            let text = `Error tipo incorrecto.`;
            if(type == "R"){
                text = `Para Flash es muy importante atender su requerimiento en el menor tiempo posible. Su Petición , recibido el ${formatIni} ha sido identificado con Ticket No. XXXX, será contestada a más tardar el día ${formatFin} a través del mismo medio de atención por el que la presentó o por el medio de su elección. Si su Petición no es atendida en la fecha indicada, se entenderá que ha sido resuelta a su favor. (Esto se llama Silencio Administrativo positivo).`;
            }else if(type == "P"){
                text = `Para Flash es muy importante atender su requerimiento en el menor tiempo posible. Su Petición , recibido el ${formatIni} ha sido identificado con Ticket No. XXXX CUN No. XXX, será contestada a más tardar el día ${formatFin} a través del mismo medio de atención por el que la presentó o por el medio de su elección. Si su Petición no es atendida en la fecha indicada, se entenderá que ha sido resuelta a su favor. (Esto se llama Silencio Administrativo positivo).`;
            }
            navigator.clipboard.writeText(text);
        },
        formatDateSlashToText(strDate){
            const monthText = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ]

            let parts = strDate.split("/");
            let dia = parts[0];
            let numberOfMonth = parseInt(parts[1])-1;
            let mes = monthText[numberOfMonth];
            let anio = parts[2];
            return dia+" de "+mes+" del "+anio;
        }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 500)

        this.loader = null
      },
    },
  }
</script>
